import { OPPO_WL_CLID, PLAYGAMA_CLIDS } from '@/constants/general'
import { type AdHandlerConfig } from '@/modules/adv/types'
import { MINIPLAY_CLID } from '@/modules/main-frame/custom-integrations/miniplay'
import { XIAOMI_TEST_CLID } from '@/modules/main-frame/custom-integrations/xiaomi'
import { AdProvidersSettings } from '@/types'

export type Config = {
    isInitGameScreenHidden?: boolean
    isPreloaderDisabled?: boolean
    isCustomized?: boolean
    isPrerollDisabled?: boolean
    isSmartAdDisabled?: boolean
    adDisabled?: true
    adProvidersDisabled?: true
    inGameAdHandlerConfig?: Partial<AdHandlerConfig> | undefined
    fallBackProviders?: AdProvidersSettings[]
}

export const LAGGED_CLID = 'lagged'
export const LAGGED_ADDITIONAL_CLID = 'p_8460bdc6-2f32-4753-b553-fa84d1fc40d7'
const COLOR_YOUR_EYE = 'p_c52cb451-4333-4b80-b6f8-08c68f9f993c'
export const JOGOS_360 = 'p_7a9df8c8-c8b2-433e-b06a-da47dc15b6ec'
const GAME_16_CLID = 'p_a48fc4e4-2388-4403-a1b9-fce2b19a1f97'
const Y8_CLID = 'p_d1847169-9b0a-4ac8-a722-3ad587f8841c'
export const PLAY_GAMES_CLID = 'p_ae5af802-1a10-4cc0-9e2a-989216d478af'
const RHM_CLID = 'p_b0f10b8c-2a74-481f-bcbc-67b689bdc92f'
const SPIElE_CLID = '5496748'
const XIAOMI_TWA = 'xiaomi_direct_twa'
const SAMSUNG_TWA = 'samsung_direct_twa'
const HUAWEI_TWA = 'huawei_direct_twa'
const GOOGLE_TWA = 'google_direct_twa'
const AMAZON_TWA = 'amazon_direct_twa'
const UPTODOWN_TWA = 'uptodown_direct_twa'
const IOS_TWA = 'ios_direct_twa'
const POCKET_HEAVEN_GAMES = 'pockethavengames'
const PLAY_123_COM = 'p_9dc4c68b-0c7a-4a99-bc07-b1e64e4125cd'
// Example domains using this shared CLID:
// https://mrracer.online
// https://manrunner2048.io
// https://deadlydescent.net
// https://rivalsfps.com
const GAMES_SEO_DOMAINS = 'p_08b565e0-8865-412e-9d23-5f5873d45566'

export function getConfigByClid(clid: string) {
    const CONFIG: Record<string, Config> = {
        [MINIPLAY_CLID]: {
            isInitGameScreenHidden: true,
        },
        [OPPO_WL_CLID]: {
            isPreloaderDisabled: true,
            isPrerollDisabled: true,
            adDisabled: true,
            adProvidersDisabled: true,
        },
        [LAGGED_CLID]: {
            isInitGameScreenHidden: true,
            isCustomized: true,
            isPrerollDisabled: true,
        },
        [LAGGED_ADDITIONAL_CLID]: {
            isInitGameScreenHidden: true,
            isCustomized: true,
            isPrerollDisabled: true,
        },
        [PLAY_GAMES_CLID]: {
            isPrerollDisabled: true,
            isInitGameScreenHidden: true,
            isCustomized: true,
            inGameAdHandlerConfig: {
                interstitial: {
                    timeout: 180_000,
                },
            },
        },
        [Y8_CLID]: {
            isPreloaderDisabled: true,
            isPrerollDisabled: true,
            isInitGameScreenHidden: true,
            inGameAdHandlerConfig: {
                interstitial: {
                    timeout: 180_000,
                },
            },
        },
        [GAME_16_CLID]: {
            inGameAdHandlerConfig: {
                interstitial: {
                    timeout: 180_000,
                },
            },
        },
        [SPIElE_CLID]: {
            inGameAdHandlerConfig: {
                interstitial: {
                    timeout: 180_000,
                },
            },
        },
        [RHM_CLID]: {
            isPrerollDisabled: true,
            isInitGameScreenHidden: true,
        },
        [XIAOMI_TEST_CLID]: {
            isInitGameScreenHidden: true,
            adDisabled: true,
        },
        [XIAOMI_TWA]: {
            isPrerollDisabled: true,
            isInitGameScreenHidden: true,
            adDisabled: true,
            inGameAdHandlerConfig: {
                interstitial: {
                    timeout: 180_000,
                },
            },
        },
        [SAMSUNG_TWA]: {
            isPrerollDisabled: true,
            isInitGameScreenHidden: true,
            adDisabled: true,
            inGameAdHandlerConfig: {
                interstitial: {
                    timeout: 180_000,
                },
            },
        },
        [HUAWEI_TWA]: {
            isPrerollDisabled: true,
            isInitGameScreenHidden: true,
            adDisabled: true,
            inGameAdHandlerConfig: {
                interstitial: {
                    timeout: 180_000,
                },
            },
        },
        [GOOGLE_TWA]: {
            isPrerollDisabled: true,
            isInitGameScreenHidden: true,
            adDisabled: true,
            inGameAdHandlerConfig: {
                interstitial: {
                    timeout: 180_000,
                },
            },
        },
        [AMAZON_TWA]: {
            isPrerollDisabled: true,
            isInitGameScreenHidden: true,
            adDisabled: true,
            inGameAdHandlerConfig: {
                interstitial: {
                    timeout: 180_000,
                },
            },
        },
        [UPTODOWN_TWA]: {
            isPrerollDisabled: true,
            isInitGameScreenHidden: true,
            adDisabled: true,
            inGameAdHandlerConfig: {
                interstitial: {
                    timeout: 180_000,
                },
            },
        },
        [IOS_TWA]: {
            isPrerollDisabled: true,
            adDisabled: true,
            isInitGameScreenHidden: true,
        },
        [POCKET_HEAVEN_GAMES]: {
            isInitGameScreenHidden: true,
            isPrerollDisabled: true,
        },
        [COLOR_YOUR_EYE]: {
            isCustomized: true,
        },
        [JOGOS_360]: {
            isCustomized: true,
        },
        [PLAY_123_COM]: {
            isPrerollDisabled: true,
            inGameAdHandlerConfig: {
                interstitial: {
                    timeout: 180_000,
                },
            },
        },
        [GAMES_SEO_DOMAINS]: {
            isPrerollDisabled: true,
        },
        'p_1569629a-4f76-4313-b8e7-f55aed918171': {
            inGameAdHandlerConfig: {
                interstitial: {
                    timeout: 180_000,
                    initialDelayInMs: 180_000,
                },
            },
        },
    }

    return {
        // any clid except Playgama's does not have smart ads
        isSmartAdDisabled: Object.values(PLAYGAMA_CLIDS).includes(clid) === false,
        ...(CONFIG[clid] || {}),
    }
}
